export const GETAUDITLOGITEMS = {
  REQUEST: 'ServiceRequestAuditLog/GetAuditLogItems/Request',
  SUCCESS: 'ServiceRequestAuditLog/GetAuditLogItems/Success',
  FAILURE: 'ServiceRequestAuditLog/GetAuditLogItems/Failure'
};
